export default __webpack_public_path__ + "921c2a63f06ac4cfaf08e39dcf3a2286.jpg";